import React, { useState } from 'react';
import axios from 'axios';
import RenderError from '../../components/RenderError';
import Success from '../../../equipmentSurveys/components/Success';
import Submit from '../../../equipmentSurveys/components/Submit';

function CurrentPractices({
  applicationData: {
    aid,
    chickensRaised,
    chickensRaisedOther,
    heatPower,
    engineChemicals,
    emptyDays,
    facilitySquareFeet,
    sanitizeTimes
  },
  setApplicationData,
  initialView,
  setView
}) {
  const [formData, setFormData] = useState({
    aid: aid ?? '',
    chickensRaised: chickensRaised ?? '',
    chickensRaisedOther: chickensRaisedOther ?? '',
    heatPower: heatPower ?? '',
    engineChemicals: engineChemicals ?? '',
    emptyDays: parseInt(emptyDays) ?? '',
    facilitySquareFeet: parseInt(facilitySquareFeet) ?? '',
    sanitizeTimes: parseInt(sanitizeTimes) ?? ''
  });
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');

  const handleInputChange = (event) => {
    const { value, name } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setErrors([]);

    axios
      .post(
        window.wlPipConfig.ajaxUrl +
          '?action=wl_fip_save_poultry_house_current_practices',
        formData
      )
      .then((res) => {
        setLoading(false);
        setSuccess(res.data.data.message);
        setApplicationData(res.data.data.applicationData);
        setTimeout(() => setView(initialView), 1000);
      })
      .catch((err) => {
        setLoading(false);
        setErrors(err.response.data.data);
      });
  };

  return (
    <div className="fip-unit-form">
      <div className="fip-unit-form-fields">
        <div className="grid__col-xs-12 u--padding-left-0">
          <div className="form__field form__field--required">
            <label className="form__label">
              How many chickens do you raise each year? (Ranges: 100 to 499, 500 to 2499, 2500 to 9999, 10,000 to 19999, More than 20,000, Other (specify))
            </label>
            <select
              className="form__input form__input--lg"
              name="chickensRaised"
              value={formData.chickensRaised}
              onChange={handleInputChange}
            >
              <option value="">Select a range</option>
              <option value="100-499">100 to 499</option>
              <option value="500-2499">500 to 2499</option>
              <option value="2500-9999">2500 to 9999</option>
              <option value="10000-19999">10,000 to 19999</option>
              <option value="20000+">More than 20,000</option>
              <option value="other">Other (specify)</option>
            </select>
            {errors.chickensRaised && <RenderError error={errors.chickensRaised} />}
            {formData.chickensRaised === 'other' && (
              <div className="u--margin-top-10">
                <input
                  type="text"
                  className="form__input form__input--lg"
                  name="chickensRaisedOther"
                  value={formData.chickensRaisedOther}
                  onChange={handleInputChange}
                  placeholder="Please specify"
                />
                {errors.chickensRaisedOther && <RenderError error={errors.chickensRaisedOther} />}
              </div>
            )}
          </div>
          <div className="form__field form__field--required">
            <label className="form__label">
              How did you/do you power the heat to sanitize your chicken barn before purchasing your new propane-fueled engine? (Please enter 0 if none)
            </label>
            <input
              type="text"
              className="form__input form__input--lg"
              name="heatPower"
              value={formData.heatPower}
              onChange={handleInputChange}
            />
            {errors.heatPower && <RenderError error={errors.heatPower} />}
          </div>
          <div className="form__field form__field--required">
            <label className="form__label">
              Please provide the following information about your current engines: What chemicals do you use in your program?
            </label>
            <input
              type="text"
              className="form__input form__input--lg"
              name="engineChemicals"
              value={formData.engineChemicals}
              onChange={handleInputChange}
            />
            {errors.engineChemicals && <RenderError error={errors.engineChemicals} />}
          </div>
          <div className="form__field form__field--required">
            <label className="form__label">
              How many days did the treated area need to be empty before birds could be placed back after treatment?
            </label>
            <input
              type="number"
              className="form__input form__input--lg"
              name="emptyDays"
              value={formData.emptyDays}
              onChange={handleInputChange}
            />
            {errors.emptyDays && <RenderError error={errors.emptyDays} />}
          </div>
          <div className="form__field form__field--required">
            <label className="form__label">
              How many square feet is your poultry facility?
            </label>
            <input
              type="number"
              className="form__input form__input--lg"
              name="facilitySquareFeet"
              value={formData.facilitySquareFeet}
              onChange={handleInputChange}
            />
            {errors.facilitySquareFeet && <RenderError error={errors.facilitySquareFeet} />}
          </div>
          <div className="form__field form__field--required">
            <label className="form__label">
              How many times per year do you sanitize the facility?
            </label>
            <input
              type="number"
              className="form__input form__input--lg"
              name="sanitizeTimes"
              value={formData.sanitizeTimes}
              onChange={handleInputChange}
            />
            {errors.sanitizeTimes && <RenderError error={errors.sanitizeTimes} />}
          </div>
          <Submit
            loading={loading}
            handleSubmit={handleSubmit}
            text="Save Section"
            errors={errors}
            disabled={!Boolean(aid)}
          />
          {success && <Success success={success} />}
        </div>
      </div>
    </div>
  );
}

CurrentPractices.displayName = 'CurrentPractices';
export default CurrentPractices;
